import * as z from "zod";

export const BisImportProgressSchema_ = z.object({
  importId: z.string(),
  filename: z.string(),
  totalRows: z.number(),
  processedRows: z.number(),
  progress: z.number(),
  created: z.number(),
  duplicatesSkipped: z.number(),
  invalidRowsSkipped: z.number(),
  status: z.enum([
    "preparing",
    "processing",
    "completed",
    "failed",
    "canceled",
  ]),
  error: z.string().optional(),
});
export const BisImportProgressSchema: z.ZodType<BisImportProgressSchema> =
  BisImportProgressSchema_;
export interface BisImportProgressSchema extends z.infer<
  typeof BisImportProgressSchema_
> {}

export const listBisImports = {
  name: "listBisImports" as const,
  input: z.object({
    limit: z.number().int().positive().default(20).optional(),
  }),
  output: z.object({ imports: z.array(BisImportProgressSchema) }),
};
